module.exports = __webpack_public_path__ + "static/forecast/elevation-mountains-2280cf3f7ee6af4abe7fb9fb040d47f7.png";